let config = {};

if (process.env.NODE_ENV === 'production') {
  // PROD
  config = {
    "auth0_domain": "fidelius.auth0.com",
    "auth0_clientId": "PPHwMnAp6Toq4X1usS72lRQiyiPhAtmJ",
    "auth0_audience": "https://fidelius/",
    "stripe_key": "pk_live_x09y31GJH8DgPJ7SBcU55y7600AiS75SZm",
    "auth0_metadata": "https://fidelius/app_metadata",
  };
} else {
  config = {
    "auth0_domain": "fidelius-dev.auth0.com",
    "auth0_clientId": "xytkYgum55YoOjQYkFSKp8zz4At0yWZf",
    "auth0_audience": "https://fidelus/dev",
    "stripe_key": "pk_test_iPMPSOmaf14ia1oln5SEmRei00dpTlUTbP",
    "auth0_metadata": "https://fidelus/dev/app_metadata",
  }
}

export default config;